@if (user(); as user) {
  <ng-container>
    @if (user.role==='resident' && user.extra?.ascd_code === 'CI') {
      <nz-descriptions style="margin-bottom: 10px;"
        [nzColumn]="3" nzBordered="true" nzSize="small">
        <nz-descriptions-item nzTitle="Hall">{{ user.halls.join(',') }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Room">{{ user.extra.room }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Bed">{{ user.extra.bed }}</nz-descriptions-item>
      </nz-descriptions>
    }
    <nz-card [nzTitle]="title" nzSize="small">
      <ng-template #title>
        Services
      </ng-template>
      <div nz-row [nzGutter]="[8,8]">
        @for (m of user.menuItems; track m.link) {
          <div nz-col [nzXs]="12" [nzSm]="8">
            <div class="menu-item" [routerLink]="m.link">
              <div class="icon">
                <span nz-icon [nzType]="m.icon" nzTheme="outline"></span>
              </div>
              <div style="height:40px; line-height: 1">
                <span class="title">{{ m.title }}</span>
                @if (m.subTitle) {
                  <br/><span class="title">{{ m.subTitle }}</span>
                }
              </div>
            </div>
          </div>
          } @empty {
          <div nz-col [nzXs]="24" [nzSm]="24">
            <nz-alert nzMessage="No services are available"></nz-alert>
          </div>
        }
      </div>
    </nz-card>
  </ng-container>
}

